var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5833 18.1772C11.8056 18.8716 6.25 21.9272 6.25 28.5938C6.25 36.9272 12.5 38.4897 15.625 38.4897H23.4371V30.1563H20.05C19.526 30.1563 19.2346 29.5501 19.562 29.1409L24.5116 22.9539C24.7618 22.6411 25.2375 22.6411 25.4877 22.9539L30.4373 29.1409C30.7647 29.5501 30.4733 30.1563 29.9492 30.1563H26.5621V38.4897H35.4167C38.5417 38.4897 43.75 36.4063 43.75 29.6355C43.75 23.9063 39.0625 21.823 36.4583 21.823C36.4583 18.698 33.3333 11.4063 25 11.4063C16.6667 11.4063 14.5833 18.1772 14.5833 18.1772Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.8644984d5a4754104626184c895e2827.svg";
export { ForwardRef as ReactComponent };